export default function ConceptHero() {
  return (
    <section className="relative w-full h-screen overflow-hidden bg-black">
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/79bbd12133c9c5c423ad9964f66c8be6/ffcfc912b36ae579c1fffbc916ea7a8f.jpeg"
          alt="Campaign Concept"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/50 to-black/20" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-black/40" />
      </div>

      <div className="relative z-10 flex flex-col justify-end h-full px-8 md:px-20 pb-24">
        <p
          className="text-[#4D1815] text-xs tracking-widest mb-6 fade-in-up"
          style={{ letterSpacing: '0.5em', fontFamily: "'Cormorant Garamond', serif" }}
        >
          — CAMPAIGN CONCEPT —
        </p>
        <h1
          className="text-[#EADDCC] font-light leading-none mb-6 fade-in-up"
          style={{
            fontFamily: "'Cormorant Garamond', serif",
            fontSize: 'clamp(40px, 7vw, 100px)',
            letterSpacing: '0.08em',
          }}
        >
          THE BEAST
          <br />
          <em className="italic text-[#EADDCC]/70">WITHIN</em>
        </h1>
        <p
          className="text-[#EADDCC]/50 text-sm md:text-base font-light max-w-md fade-in-up"
          style={{ fontFamily: "'Cormorant Garamond', serif", letterSpacing: '0.05em', lineHeight: 1.8 }}
        >
          Lipstick is not cosmetic.
          <br />
          It is the medium of desire.
        </p>
      </div>
    </section>
  );
}
